import { Popup } from "devextreme-react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table2 } from "../../../../components/Table2/Table2";
import { Toster } from "../../../../components/Toster/Toster";
import { setresetValue } from "../../../../reducer/participantNoteReducer";
import { DeleteViewImage } from "./DeleteViewImage";
import { EditAttachment } from "./EditAttechment";
import ViewAttachmentPopup from "./ViewAttachmentPopup";

const EditAttachmentpopup = ({
  editAttachmentPopupOpen,
  seteditAttachmentPopupOpen,
  AttachmenteditData,
  attachmentCategories,
  userinfo,
  toastConfig,
  setToastConfig,
  attachmentfunction,
  getphotoTableData,
}) => {
  const { resetValue } = useSelector((store) => store.participateNotes);
  const dispatch = useDispatch();
  return (
    <Popup
      visible={userinfo?.gPersonId && editAttachmentPopupOpen}
      onHiding={() => {
        dispatch(setresetValue(!resetValue));
        seteditAttachmentPopupOpen(false);
      }}
      showTitle={false}
      width={700}
      height={420}
      showCloseButton={true}
      hideOnOutsideClick={false}
    >
      <EditAttachment
        seteditAttachmentPopupOpen={seteditAttachmentPopupOpen}
        AttachmenteditData={AttachmenteditData}
        attachmentCategories={attachmentCategories}
        userinfo={userinfo}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        attachmentfunction={attachmentfunction}
        getphotoTableData={getphotoTableData}
      />
    </Popup>
  );
};
const DeleteImagePopUp = ({
  deletePopup,
  setdeletePopup,
  getbinaryDataIdInAttachment,
  toastConfig,
  setToastConfig,
  attachmentfunction,
  getphotoTableData,
}) => {
  return (
    <>
      <Popup
        visible={getbinaryDataIdInAttachment && deletePopup}
        onHiding={() => {
          setdeletePopup(false);
        }}
        showTitle={false}
        width={500}
        height={250}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <DeleteViewImage
          setdeletePopup={setdeletePopup}
          getbinaryDataIdInAttachment={getbinaryDataIdInAttachment}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          attachmentfunction={attachmentfunction}
          getphotoTableData={getphotoTableData}
        />
      </Popup>
    </>
  );
};

const Tablecoloum = [
  { title: "", moreoption: true, customwidth: "50px" },
  {
    title: "Edit",
    Action: true,
  },
  { title: "View", viewImage: true },
  { title: "Download", download: true },
  {
    title: "Filename",
  },
  { title: "Category" },
  {
    title: "Description",
  },
  {
    title: "DOE",
    datetime: true,
    customwidth: "150px"
  },
  {
    title: "Entered By",
    customwidth: "150px"
  },
];

export const AllAttachmentFiles = ({
  userinfo,
  loading,
  data,
  attachmentCategories,
  attachmentfunction,
  getphotoTableData,
}) => {
  const [AttachmenteditData, getAttachmenteditData] = useState({});
  const [editAttachmentPopupOpen, seteditAttachmentPopupOpen] = useState(false);
  const [deletePopup, setdeletePopup] = useState(false);
  const [getbinaryDataIdInAttachment, setgetbinaryDataIdInAttachment] = useState("");
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [fileName, setFileName] = useState("");
  return (
    <>
      <EditAttachmentpopup
        seteditAttachmentPopupOpen={seteditAttachmentPopupOpen}
        editAttachmentPopupOpen={editAttachmentPopupOpen}
        AttachmenteditData={AttachmenteditData}
        attachmentCategories={attachmentCategories}
        userinfo={userinfo}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        attachmentfunction={attachmentfunction}
        getphotoTableData={getphotoTableData}
      />
      <DeleteImagePopUp
        deletePopup={deletePopup}
        setdeletePopup={setdeletePopup}
        getbinaryDataIdInAttachment={getbinaryDataIdInAttachment}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        attachmentfunction={attachmentfunction}
        getphotoTableData={getphotoTableData}
      />
      <ViewAttachmentPopup
        viewerOpen={viewerOpen}
        setViewerOpen={setViewerOpen}
        fileUrl={fileUrl}
        fileType={fileType}
        fileName={fileName} 
      />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <div className="AllAttachmentFiles_component">
        <div className="AllAttachmentFiles_component_table">
          <Table2
            Tablecoloum={Tablecoloum}
            tableRow={data}
            editTable={false}
            load={loading}
            coloumWidthText={"AttachmentTable"}
            height={"calc(100vh - 430px)"}
            mandatoryColoum={"DOE"}
            showTotalBlock={false}
            getAttachmenteditData={getAttachmenteditData}
            seteditAttachmentPopupOpen={seteditAttachmentPopupOpen}
            attachmentRightCickPopup={true}
            setattachmentdeletePopup={setdeletePopup}
            setgetbinaryDataIdInAttachment={setgetbinaryDataIdInAttachment}
            setSelectedAttachment={setSelectedAttachment}
            setViewerOpen={setViewerOpen}
            setFileUrl={setFileUrl}
            setFileType={setFileType}
            setFileName={setFileName} 
          />
        </div>
      </div>
    </>
  );
};
